import { sendWebsocketMessage } from '../../../../../App';
import { getMarketDataRoute } from '../../marketDataRouting';
/**
 * I cant remember what goes in this object honestly... I think its like the datasource, watchlistName, and symbol, but ya, cant say for sure...s
 * @param {} data
 */
export function addSymbol(data) {
  if (data.symbol) {
    const route = getMarketDataRoute({
      dataSource: data.dataSource,
      brokerage: data.brokerage,
      messageType: 'addSymbol',
      symbol: data.symbol,
    });
    if (!route.valid) {
      return;
    }
    const message = {
      messageType: 'addSymbol',
      addSymbol: {
        ...data,
        brokerage: route.brokerage,
      },
    };
    sendWebsocketMessage(message);
  }
}

/*
data = {
  symbolL: amd,
  dataSource: 'LIVE',
  watchlist_name: moduleId
}

*/
